module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trips-page"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "product-header"
  }, [(_vm.view.Images && _vm.view.Images.length) ? _c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.view.Images[0]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "pd-title"
  }, [_vm._v(_vm._s(_vm.view.HotelName))]), _vm._v(" "), _c('div', {
    staticClass: "product-meta"
  }, [(_vm.view.Address) ? _c('span', [_c('i', {
    staticClass: "fas fa-map-marker-alt fa-fw"
  }), _vm._v("\n          " + _vm._s(_vm.view.Address) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.cleanTags(_vm.view.Description)))])])]), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
    }
  })]), _vm._v("\n    Choose the perfect room for your stay\n  ")]), _vm._v(" "), _vm._l((_vm.rooms.HotelRoomsDetails), function(room) {
    return _c('div', {
      staticClass: "room-card"
    }, [_c('div', {
      staticClass: "room-header"
    }, [_c('div', {
      staticClass: "room-title-wrap"
    }, [_c('div', {
      staticClass: "room-title"
    }, [_vm._v(_vm._s(room.RoomTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "room-tags"
    }, _vm._l((room.OtherAmennities), function(am) {
      return _c('span', {
        class: ['room-tag', {
          free: am.toLowerCase().includes('free')
        }]
      }, [_vm._v(_vm._s(am))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "room-price"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Total Price")]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(_vm.currencySymbol[_vm.currency.code]))]), _vm._v("\n          " + _vm._s(_vm.applyCurrency(room.Price, false)))]), _vm._v(" "), _c('div', {
      staticClass: "per"
    }, [_vm._v("per night")])])]), _vm._v(" "), (room.CancellationPolicies && room.CancellationPolicies.length) ? _c('div', {
      staticClass: "cancel-info"
    }, [_c('i', {
      staticClass: "fas fa-check fa-fw"
    }), _vm._v(" "), _c('div', {
      staticClass: "cancel-text",
      domProps: {
        "innerHTML": _vm._s(_vm.cancelPolicy(room.CancellationPolicies))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "room-footer"
    }, [_c('div', {
      staticClass: "room-meta"
    }, [_vm._v("Hotel Code: 1514682")]), _vm._v(" "), _c('button', {
      staticClass: "room-btn",
      on: {
        "click": function($event) {
          _vm.getBlockData(room)
        }
      }
    }, [_vm._v("Select Room")])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c58a6ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c58a6ca","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DHotel/rooms/index.vue
// module id = 2071
// module chunks = 0